<template>
    <div class="map-config">
      <div class="page-header">
        <h2 class="page-title">地图配置</h2>
        <p class="page-desc">配置地图服务，用于门店定位、路线规划等功能</p>
      </div>
  
      <div class="config-container">
        <el-card class="config-card" shadow="hover">
          <template #header>
            <div class="card-header-title">
              <el-icon><MapLocation /></el-icon>
              <span>地图服务配置</span>
            </div>
          </template>
  
          <el-form :model="form" ref="formRef" label-width="120px">
            <el-form-item label="地图类型" required>
              <el-select v-model="form.map_type" placeholder="请选择地图类型" style="width: 300px" @change="onMapTypeChange">
                <el-option label="腾讯地图" value="tencent" />
                <el-option label="百度地图" value="baidu" disabled />
                <el-option label="高德地图" value="amap" disabled />
                <el-option label="天地图" value="tianditu" disabled />
              </el-select>
              <div class="form-tip">其他地图类型即将开放，敬请期待</div>
            </el-form-item>
  
            <template v-if="form.map_type === 'tencent'">
              <el-form-item label="地图 KEY">
                <el-input v-model="form.tencent_map_key" placeholder="请输入腾讯地图 KEY" />
                <div class="form-tip">在腾讯位置服务控制台获取</div>
              </el-form-item>
  
              <el-form-item label="地图 SK（可选）">
                <el-input v-model="form.tencent_map_sk" placeholder="请输入腾讯地图 SK" show-password />
                <div class="form-tip">用于签名校验，可不填</div>
              </el-form-item>
            </template>
  
            <el-form-item class="save-btn-item">
              <el-button type="primary" @click="saveConfig" :loading="submitting" size="default" class="save-btn">
                <el-icon><Check /></el-icon>保存配置
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import Cookies from 'js-cookie'
  import axios from 'axios'
  import config from '@/config'
  import { MapLocation, Check } from '@element-plus/icons-vue'
  
  export default {
    name: 'MapConfig',
    components: { MapLocation, Check },
    setup() {
      const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
      const storeId = ref(userInfo.id || 0)
      const agentId = ref(userInfo.agent_id || 0)
  
      const formRef = ref(null)
      const submitting = ref(false)
  
      const form = reactive({
        map_type: 'tencent',
        tencent_map_key: '',
        tencent_map_sk: ''
      })
  
      const fetchConfig = async () => {
        const loading = ElLoading.service({ text: '加载中...' })
        try {
          const res = await axios.get(`${config.BASE_URL}/shop/api/map_api.php`, {
            params: { store_id: storeId.value, agent_id: agentId.value }
          })
          if (res.data.code === 200 && res.data.data) {
            Object.assign(form, res.data.data)
          }
        } catch (err) {
          console.error(err)
          ElMessage.error('获取配置失败')
        } finally {
          loading.close()
        }
      }
  
      const onMapTypeChange = () => {
        if (form.map_type !== 'tencent') {
          ElMessage.info('其他地图类型暂未开放，敬请期待')
          form.map_type = 'tencent'
        }
      }
  
      const saveConfig = async () => {
        submitting.value = true
        const loading = ElLoading.service({ text: '保存中...' })
  
        try {
          const payload = {
            store_id: storeId.value,
            agent_id: agentId.value,
            map_type: form.map_type,
            tencent_map_key: form.tencent_map_key,
            tencent_map_sk: form.tencent_map_sk
          }
          const res = await axios.post(`${config.BASE_URL}/shop/api/map_api.php`, payload)
  
          if (res.data.code === 200) {
            ElMessage.success('保存成功')
          } else {
            ElMessage.error(res.data.message || '保存失败')
          }
        } catch (err) {
          ElMessage.error('保存失败')
        } finally {
          submitting.value = false
          loading.close()
        }
      }
  
      onMounted(() => {
        fetchConfig()
      })
  
      return {
        form,
        formRef,
        submitting,
        saveConfig,
        onMapTypeChange
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  .map-config {
    .page-header {
      margin-bottom: 24px;
  
      .page-title {
        font-size: 24px;
        font-weight: 600;
        color: #1a1a2e;
        margin-bottom: 4px;
      }
  
      .page-desc {
        font-size: 14px;
        color: #8c8c8c;
      }
    }
  
    .config-container {
      width: 100%;
      max-width: 800px;
    }
  
    .config-card {
      border-radius: 16px;
      overflow: hidden;
    }
  
    .card-header-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-weight: 500;
    }
  
    .form-tip {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
      line-height: 1.4;
    }
  
    .save-btn-item {
      margin-top: 16px;
    }
  
    .save-btn {
      padding: 8px 24px;
      font-size: 14px;
      font-weight: 500;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
      border: none !important;
    }
  }
  </style>